import { useGetBanksDetailsQuery } from "services/bankApi";

export default function useBanks() {
  const {
    data: banks,
    isLoading,
    isFetching,
    isError,
    error,
  } = useGetBanksDetailsQuery();

  //   console.log("BANK DATA", data);

  return {
    banks,
    isLoading,
    isFetching,
    isError,
    error,
  };
}
